export default __webpack_public_path__ + "static/media/eat.26f0eed2.svg";